import { display } from '../tools/display';
import { ONE_MINUTE, ONE_SECOND } from '../tools/utils/timeUtils';
import { findAllCommaSeparatedValues, findCommaSeparatedValue, findCommaSeparatedValues, generateUUID } from '../tools/utils/stringUtils';
import { buildUrl } from '../tools/utils/urlPolyfill';
export function setCookie(name, value) {
  var expireDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var options = arguments.length > 3 ? arguments[3] : undefined;
  var date = new Date();
  date.setTime(date.getTime() + expireDelay);
  var expires = "expires=".concat(date.toUTCString());
  var sameSite = options && options.crossSite ? 'none' : 'strict';
  var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
  var secure = options && options.secure ? ';secure' : '';
  var partitioned = options && options.partitioned ? ';partitioned' : '';
  document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
/**
 * Returns the value of the cookie with the given name
 * If there are multiple cookies with the same name, returns the first one
 */

export function getCookie(name) {
  return findCommaSeparatedValue(document.cookie, name);
}
/**
 * Returns all the values of the cookies with the given name
 */

export function getCookies(name) {
  return findAllCommaSeparatedValues(document.cookie).get(name) || [];
}
var initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 *
 * ⚠️ If there are multiple cookies with the same name, returns the LAST one (unlike `getCookie()`)
 */

export function getInitCookie(name) {
  if (!initCookieParsed) {
    initCookieParsed = findCommaSeparatedValues(document.cookie);
  }

  return initCookieParsed.get(name);
}
export function resetInitCookies() {
  initCookieParsed = undefined;
}
export function deleteCookie(name, options) {
  setCookie(name, '', 0, options);
}
export function areCookiesAuthorized(options) {
  if (document.cookie === undefined || document.cookie === null) {
    return false;
  }

  try {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_cookie_test_".concat(generateUUID());
    var testCookieValue = 'test';
    setCookie(testCookieName, testCookieValue, ONE_MINUTE, options);
    var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
    deleteCookie(testCookieName, options);
    return isCookieCorrectlySet;
  } catch (error) {
    display.error(error);
    return false;
  }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */

var getCurrentSiteCache;
export function getCurrentSite() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.hostname;
  var referrer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.referrer;

  if (getCurrentSiteCache === undefined) {
    var defaultHostName = getCookieDefaultHostName(hostname, referrer);

    if (defaultHostName) {
      // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
      // the test cookie lifetime
      var testCookieName = "dd_site_test_".concat(generateUUID());
      var testCookieValue = 'test';
      var domainLevels = defaultHostName.split('.');
      var candidateDomain = domainLevels.pop();

      while (domainLevels.length && !getCookie(testCookieName)) {
        candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
        setCookie(testCookieName, testCookieValue, ONE_SECOND, {
          domain: candidateDomain
        });
      }

      deleteCookie(testCookieName, {
        domain: candidateDomain
      });
      getCurrentSiteCache = candidateDomain;
    }
  }

  return getCurrentSiteCache;
}

function getCookieDefaultHostName(hostname, referrer) {
  try {
    return hostname || buildUrl(referrer).hostname;
  } catch (_a) {// Ignore
  }
}

export function resetGetCurrentSite() {
  getCurrentSiteCache = undefined;
}